import { ActionType, IGetProduct, IPostConnectProduct, IPreviewProduct } from './model'
import { Action, ActionCallback, IValidationCallback, Nullable } from '../model'

export const postConnectProductsAction = (
  payload: IPostConnectProduct,
  callback: IValidationCallback
): ActionCallback<IPostConnectProduct> => ({
  type: ActionType.POST_CONNECT_PRODUCT,
  payload,
  callback,
})

export const getProductListAction = (payload: { page: number }): Action<{ page: number }> => ({
  type: ActionType.GET_PRODUCT_LIST,
  payload,
})

export const getProductAction = (payload: IGetProduct): Action<IGetProduct> => ({
  type: ActionType.GET_PRODUCT,
  payload,
})

export const getProductNewAction = (payload: IGetProduct): Action<IGetProduct> => ({
  type: ActionType.GET_PRODUCT_NEW,
  payload,
})

export const setPreviewProductAction = (payload: Nullable<IPreviewProduct>): Action<Nullable<IPreviewProduct>> => ({
  type: ActionType.SET_PREVIEW_PRODUCT,
  payload,
})
